import React from 'react';

const PlayVideoCourseIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g id='ondemand_video' clipPath='url(#clip0_4714_46737)'>
      <path
        id='Vector'
        d='M9 7V15L16 11L9 7ZM21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_4714_46737'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);

export default PlayVideoCourseIcon;
